export default {
    blog: {
        Free: 'Free',
        Guide: ' Guides',
        Search: 'Search',
        posts: ' Posts',
        column: 'Column View',
        list: 'List View',
        toggle: 'toggle view style',
        noFilter: 'No Filter',
        article: 'article',
        guide: 'guide',
        minRead: ' min read',
        articles: 'Articles',
        disc: 'NobleWills has prepared these guides and articles in good faith and are intended to be used as a guide only. None of its statements, claims, or contents should be construed as advice or a recommendation. Inclusion of the name, logo or other identification of any companies on this platform does not constitute endorsement or recommendations of the goods or services of those companies.',
        willGuideTitleHK: 'How do I write my Will Guide | Free Guide',
        willGuideTitleSG: 'How do I write my Will Guide | Free Guide',
        willGuideTitleUS: 'How do I write my Will Guide | Free Guide',
        willGuideTitleGB: 'How do I write my Will Guide | Free Guide',
        willGuideDescriptionHK:
            'How to write a Will for Hong Kong guide. Follow this guide as you use the online Will service to understand what is in the Will and what to consider.',
        willGuideDescriptionSG:
            'How to write a Will for Singapore guide. Follow this guide as you use the online Will service to understand what is in the Will and what to consider.',
        willGuideDescriptionUS:
            'How to write a Will for the United States guide. Follow this guide as you use the online Will service to understand what is in the Will and what to consider.',
        willGuideDescriptionGB:
            'How to write a Will for the United Kingdom guide. Follow this guide as you use the online Will service to understand what is in the Will and what to consider.',
        willGuideKeywordsHK: 'How to write a Will, Hong Kong Will guide, What is in a will, HK Will service',
        willGuideKeywordsSG: 'How to write a Will, Singapore Will guide, What is in a will, Singapore Will service',
        willGuideKeywordsUS: 'How to write a Will, American Will guide, What is in a will, American Will service',
        willGuideKeywordsGB: 'How to write a Will, UK Will guide, What is in a will, UK Will service',
        'guide-how-do-i-write-my-will': 'How do I write my Will?',
        willGuideDescription: "Want to write your Will and don't know where to start? This collection of articles will help guide you through the process from start to finish.",
        tempDisc:
            'DISCLAIMER: This article is for general information only and does not constitute legal advice. While many simple estates can be managed using reliable online Will-writing tools, more complex situations may require tailored advice from a professional.',
    },
};
